
import {React, useEffect, useState} from "react";
import AreaChartComponent from "./charts/areaChart";
import PieChartComponent from "./charts/pieChart";
import StatBox from "./statBox";
import { DateRangePicker } from 'rsuite';
import { addDays } from 'date-fns';
import { getStats } from "../../components/http";

import "./rsuite.css"
import styles from "./Dashboard.module.scss"

const data = [
  { value: 1048, name: 'Search Engine' },
  { value: 735, name: 'Direct' },
  { value: 580, name: 'Email' },
  { value: 484, name: 'Union Ads' },
  { value: 300, name: 'Video Ads' },
  { value: 1048, name: 'abc Engine' },
  { value: 735, name: 'ddd' },
  { value: 580, name: 'dsf' },
  { value: 484, name: 'UnewAds' },
  { value: 300, name: 'Vdfgso Ads' }
];

const predefinedRanges = [
  {
    label: 'Today',
    value: [new Date(), new Date()],
    placement: 'bottom'
  },
  {
    label: 'Yesterday',
    value: [addDays(new Date(), -1), addDays(new Date(), -1)],
    placement: 'bottom'
  },
  {
    label: 'Last 7 Days',
    value: [addDays(new Date(), -7), new Date()],
    placement: 'bottom'
  },
  {
    label: 'Last 30 Days',
    value: [addDays(new Date(), -30), new Date()],
    placement: 'bottom'
  }
];

const data1 = [
  {
    date: "2025-02-06",
    total_sum: 198
  },
  {
    date: "2025-02-07",
    total_sum: 175
  },
  {
    date: "2025-02-08",
    total_sum: 289
  },
  {
    date: "2025-02-09",
    total_sum: 134
  },
  {
    date: "2025-02-10",
    total_sum: 222
  }
  
];


const Dashboard = () => {
  const [total, setTotal] = useState({value: null, boost: null})
  const [workOrdersCount, setWorkOrdersCount] = useState({value: null, boost: null})
  const [dateRange, setDateRange] = useState(null);

  const loadMetrics = async () => {
    if (dateRange){
      console.log(dateRange)
      const isoDates = dateRange.map(date => date.toISOString());
      console.log(isoDates);
      const response = getStats(isoDates[0], isoDates[1])
      console.log(response)
    }
  }

  useEffect(() => {
    loadMetrics(dateRange)
  }, [dateRange]);

  return (
   <div className={styles.someStyle}>
    Dashboard
    <div className={styles.datePickerContainer}>
      <DateRangePicker className={styles.datePicker} showOneCalendar size="sm" showHeader={false} ranges={predefinedRanges} placeholder="Select date range" onOk={setDateRange}/>
    </div>
    <div className={`${styles.statsContainer}`}>
      <StatBox title="Total Sales" value={total.value} percentageChange={total.boost} />
      <StatBox title="Total Orders" value={workOrdersCount.value} percentageChange={workOrdersCount.boost} />
      <StatBox title="Total Customers" value={145} percentageChange={-45} />
      <StatBox title="Delivery" value={45} percentageChange={45} />
    </div>
    <div className={styles.chartsContainer}>
      <div className={styles.defaultContainer}>
        <AreaChartComponent data={data1}/>
      </div>
      <div className={styles.pieChartContainer}>
        <PieChartComponent data={data}/>
      </div>
    </div>
   </div>

  );
}
export default Dashboard;
